import $ from 'jquery';
import dailyOffersTimerTemplate from './template';

function mountTimers() {
  $('[data-daily-offer-timer]').each(function () {
    const $node = $(this);

    if ($node.data('mounted')) return;

    const variant = $node.data('timer-variant');

    $node.html(dailyOffersTimerTemplate({ variant }));
    $node.data('mounted', true);
  });
}

function initTimer($timer, nextOfferAt) {
  function updateTimer() {
    const now = new Date();
    const timeRemaining = nextOfferAt - now;

    if (timeRemaining <= 0) {
      $timer.find('.daily-offer-timer-title').text('Акция завершена');
      $timer.find('.timer-hours').text('00');
      $timer.find('.timer-minutes').text('00');
      $timer.find('.timer-seconds').text('00');
      return;
    }

    const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    $timer.find('.timer-hours').text(hours.toString().padStart(2, '0'));
    $timer.find('.timer-minutes').text(minutes.toString().padStart(2, '0'));
    $timer.find('.timer-seconds').text(seconds.toString().padStart(2, '0'));
  }

  updateTimer();
  setInterval(updateTimer, 1000);
}

function initTimersWithData(nextOfferAt) {
  $('.daily-offer-timer').each(function () {
    const $timer = $(this);

    if ($timer.data('timer-initialized')) return;

    initTimer($timer, nextOfferAt);
    $timer.data('timer-initialized', true);

    $timer.removeClass('hidden');
    $timer.siblings('.daily-offers-timer-skeleton').remove();
  });
}

$(document).ready(function () {
  const observer = new MutationObserver(() => {
    mountTimers();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  mountTimers();

  $.get('/next_daily_offer_time', function (data) {
    const nextOfferAt = new Date(data.next_daily_offer_at);

    initTimersWithData(nextOfferAt);

    const dataObserver = new MutationObserver(() => {
      initTimersWithData(nextOfferAt);
    });

    dataObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
});
